import { useNumberPlaceholderLogoCreateViewModel } from '../vmHooks/useNumberPlaceholderLogoCreateViewModel'
import { NumberPlaceholderLogoCreate } from '../components/panel/number-placeholder-logo-create.component'

export function NumberPlaceholderLogoCreateWrapper() {
  const vm = useNumberPlaceholderLogoCreateViewModel()
  return <NumberPlaceholderLogoCreate {...vm} />
}